// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import i18n from '@/i18n'
import ripple from 'vuetify/lib/directives/ripple'
import { VDialog } from 'vuetify/lib'

Vue.use(Vuetify, {
  directives: { ripple },
  options: {
    customProperties: true,
  },
})

// правим дефолтные пропсы для всех v-dialog
if (VDialog && VDialog.options && VDialog.options.props) {
  VDialog.options.props.overlayColor.default = '#000'
  VDialog.options.props.overlayOpacity.default = 0.8
}

const theme = {
  primary: '#ff9100', // '#E91E63',
  secondary: '#9C27b0',
  accent: '#e91e63',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: { expand: 'mdi-menu-down' },
  },
  lang: { t: (key, ...params) => i18n.t(key, params) },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  defaults: {
    VDialog: {
      overlayColor: '#000',
      overlayOpacity: 0.7,
    },
  },
})
